import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MenuItem, PrimeIcons } from 'primeng/api'
import {
    Applicationpreference,
    RecentlyVisited,
    ReportCategory,
    ReportCategoryDto,
    UiPreferences,
} from '../../../api/models'
import {
    AppPreferencesService,
    GlobalSettingsService,
    PatientService,
    RecentlyVisitedService,
    ReportCategoryService,
    ReportsService,
} from '../../../api/services'
import { AppComponent } from '../../../app.component'
import { CareFinitySession } from '../../services/CareFinitySession'
import { SelectedPatientService } from '../patient/patient-list/patient-service'
import { takeUntil, BehaviorSubject, switchMap, Subscription, Observable, interval, Subject, startWith } from 'rxjs'

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.css'],
})
export class AppMenuComponent implements OnInit, OnDestroy {
    preferences: UiPreferences = {}
    ptVisited: RecentlyVisited[] = []
    model: any[]
    ptmodel: any[]
    adminmodel: any[]
    resultmodel: any[]
    recentlyvisptmodel: any[]
    reportsCategoriesModel: ReportCategoryDto[]
    item: MenuItem
    index: number = 0
    isPatientArchived = false
    reportsPatientsModel: any[]
    destroy = new Subject<void>()
    recenPatientSubscription: Subscription
    roles: any
    isArchiveInstance = CareFinitySession.practiceSettings.isArchiveInstance;

    showSignificantEvent = CareFinitySession.practiceSettings.isSignificantEvent;
    showPatientRestore = CareFinitySession.practiceSettings.showRestoreTabToUser;
    applicationPreferences: Observable<Applicationpreference>

    constructor(
        public app: AppComponent,
        private globalsettingService: GlobalSettingsService,
        private recentVispt: RecentlyVisitedService,
        private router: Router,
        private _reportCategory: ReportCategoryService,
        private selectedPatientService: SelectedPatientService,
        private patientService: PatientService,
        private _reportsService: ReportsService,
        private appPreferencesService: AppPreferencesService

    ) {

        this.applicationPreferences = interval(1 * 60 * 1000).pipe(startWith(0),switchMap(_ => this.appPreferencesService.appPreferencesGetPreferences()), takeUntil(this.destroy))



    }
    ngOnDestroy(): void {
        console.log('destrying menu....')
        this.destroy.next();
        this.destroy.complete()
        this.recenPatientSubscription.unsubscribe()
    }

    ngOnInit() {

        this.selectedPatientService.currentPatient.pipe().subscribe((patient) => {
            this.isPatientArchived = patient?.isPatientArchived
        })


            this.roles = CareFinitySession.user.roles;
            this.getPreferences()
            this.getPtatientVisited()

     
       
    }

    getPtatientVisited() {
        this.recenPatientSubscription = this.selectedPatientService
            .getPatient()
            .pipe(
                switchMap((_) => {
                    return this.recentVispt.recentlyVisitedGetRecentlyVisitedPatientRecords(
                        {
                            PracticeId: localStorage.getItem('PracticeId'),
                        },
                    )
                }),
            )
            .subscribe((result) => {
                console.log('recently visited are ', result)
                this.ptVisited = result
                this.SetMenuItems()
            })



        if (this.userRole?.viewPatientReports) {

            this._reportsService
                .reportsGetReportTypeList({
                    reportType: 1,
                })
                .subscribe(
                    (result) => {
                        debugger
                        this.reportsPatientsModel = result
                        this.SetMenuItems()
                    },
                    (err) => {
                        console.error('Error ', err)
                    },
                )
        }


        if (this.userRole?.viewReports) {
            this._reportCategory.reportCategoryGetByRoleId({}).subscribe((result) => {
                this.reportsCategoriesModel = result
                this.SetMenuItems()

            })
        } else {
            this.SetMenuItems()
        }
    }

    getPreferences() {
        this.globalsettingService
            .globalSettingsGetGlobalSettings({})
            .subscribe((result) => {
                this.preferences = result
            })
    }

    get userRole() {
        return this.roles;
    }

    SetMenuItems() {
        this.generalmodelsetup()

        this.getReportsOfPatientModelSetup()

        this.patientmodelsetup()

        this.getReportsCategoriesModelSetup()

        this.recentlyvisitedmodelsetup()

        this.adminmodelsetup()

        if (this.ptmodel && this.ptmodel.length > 0) {
            this.ptmodel[0].items[0].items = this.ptmodel[0].items[0].items.filter(
                (item) => item.visible == true,
            )

            debugger
            /** Patient-Report specific */
            if (this.reportsPatientList && this.reportsPatientList.length > 0) {
                let prList = this.reportsPatientList[0].items[0].items
                this.ptmodel[0].items[0].items.push(...prList)
                /*this.model.concat(this.ptmodel);*/
            }

            this.resultmodel = this.model.concat(this.ptmodel)
            this.model = this.resultmodel
            this.resultmodel = null
        }

        if (this.recentlyvisptmodel && this.recentlyvisptmodel.length > 0) {
            this.resultmodel = this.model.concat(this.recentlyvisptmodel)

            this.model = this.resultmodel
            this.resultmodel = null
        }

        if (this.reportsCategoriesList && this.reportsCategoriesList.length > 0) {
            this.resultmodel = this.model.concat(this.reportsCategoriesList)

            this.model = this.resultmodel
            this.resultmodel = null
        }

        if (this.adminmodel && this.adminmodel.length > 0) {
            this.adminmodel[0].items[0].items =
                this.adminmodel[0].items[0].items.filter((item) => item.visible == true)

            this.resultmodel = this.model.concat(this.adminmodel)
            this.model = this.resultmodel
            
            this.resultmodel = null
        }

    }

    navigateToDashboard(patient, index: number) {
        sessionStorage.setItem('ptName', patient.patientName)
       sessionStorage.setItem('ptId', patient.patientId)

        this.patientService
            .patientGetPatientDetails({
                personId: patient.patientId,
                practiceId: localStorage.getItem('EmrPracticeId'),
            })
            .subscribe((i) => {
                this.selectedPatientService.changePatient({
                    ...i,
                    patientId: patient.patientId,
                })

                //this.router
                //    .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
                //    .then(() => {
                //        this.router.navigate(['Patient/dashboard'])
                //    })

                //this.router.navigate(['Patient/dashboard/' + patient.patientName], {
                //    skipLocationChange: false,
                //})

                this.router.navigate(['Patient/dashboard/' + index], {
                    skipLocationChange: false,
                })

                ////this.router
                ////    .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
                ////    .then(() => {
                ////        this.router.navigate(['Patient/dashboard/' + index], { skipLocationChange: false })
                ////    })
            
            })
    }

    navigateToReportsView(index: number, reportId: number, reportDisplayName: string) {
        debugger
        this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => {
                this.router.navigate(['Patient/reports-view/' + index], {
                    state: { report_Id: reportId, report_DisplayName: reportDisplayName },
                    skipLocationChange: false,
                })
            })

        //this.router.navigate(['administration/reports-view'], { state: { report_Id: reportId, report_DisplayName: reportDisplayName }, skipLocationChange: false });
    }

    navigateToCategoryReportsView(
        index: number,
        reportCategoryId: number,
        reportCategoryName: string,
    ) {
        this.router.navigate(['ViewReports/category-reports-view/' + index], {
            state: {
                report_CategoryId: reportCategoryId,
                report_CategoryName: reportCategoryName,
            },
            skipLocationChange: false,
        })
    }

    generalmodelsetup() {
        this.model = [
            {
                label: '',
                icon: 'watch_later',
                visible:
                    this.userRole?.appointment && CareFinitySession.practiceSettings.showAppointment,
                   

                items: [
                    {
                        label: this.preferences?.appointments || 'Appointment' ,
                        icon: PrimeIcons.CALENDAR,
                        visible:
                            this.userRole?.appointment && CareFinitySession.practiceSettings.showAppointment,
                            routerLink: ['/appointment/list'],
                    },
                ],
            },

            {
                label: '',
                icon: 'search',
                visible: this.userRole?.patientSearch,
                items: [
                    {
                        label: 'Patient Search',
                        icon: PrimeIcons.SEARCH,
                        visible: this.userRole?.patientSearch,
                        routerLink: ['/patient/patient-search'],
                    },
                ],
            },
        ]
    }

    patientmodelsetup() {
        if (sessionStorage.getItem('ptName') != null) {
            this.ptmodel = [
                {
                    label: '',
                    icon: 'pi-users',
                    visible: sessionStorage.getItem('ptName') != null,
                    items: [
                        {
                            label: sessionStorage.getItem('ptName'),
                            icon: PrimeIcons.USERS,
                            routerLink: ['/Patient'],
                            items: [
                                {
                                    label: 'Dashboard',
                                    icon: 'dashboard',
                                    visible: true,
                                    routerLink: ['/Patient/dashboard'],
                                },

                                {
                                    label: this.preferences?.patientTimeline || 'Patient Timeline',
                                    icon: 'clock',
                                    visible: true,
                                    routerLink: ['/Patient/timeline'],
                                },
                                {
                                    label: this.preferences?.problems || 'Problems',
                                    icon: 'error',
                                    visible: this.userRole?.problems,
                                    routerLink: ['/Patient/problems/list'],
                                },
                                {
                                    label: this.preferences.allergies || 'Allergies',
                                    icon: 'pets',
                                    visible: this.userRole?.allergies,
                                    routerLink: ['/Patient/allergy/list'],
                                },
                                {
                                    label: this.preferences.medications || 'Medications',
                                    icon: 'add',
                                    visible: this.userRole?.medication,
                                    routerLink: ['/Patient/medication/list'],
                                },
                                {
                                    label: this.preferences.visits || 'Visits',
                                    icon: 'queue',
                                    visible: this.userRole?.visits,
                                    routerLink: ['/Patient/visits/list'],
                                },
                                {
                                    label: this.preferences.labs || 'Labs',
                                    icon: 'equalizer',
                                    visible: this.userRole?.labs,
                                    routerLink: ['/Patient/labs/list'],
                                },
                                {
                                    label: this.preferences.orders || 'Orders',
                                    icon: 'adjust',
                                    visible: this.userRole?.orders,
                                    routerLink: ['/Patient/orders/list'],
                                },
                                {
                                    label: this.preferences?.documents || 'Documents',
                                    icon: 'table_view',
                                    visible: this.userRole?.documents && CareFinitySession.practiceSettings.showPatientDocuments,
                                    routerLink: ["/Patient/documents/catlist"],

                                    
                                },
                                {
                                    label: this.preferences.images || 'Images',
                                    icon: 'image',
                                    visible: this.userRole?.images && CareFinitySession.practiceSettings.showPatientImage,
                                    routerLink: ['/Patient/images/list'],
                                },

                                {
                                    label: 'Patient Restore',
                                    icon: 'event',
                                    visible:
                                        this.userRole?.showRestoreTabToUser &&
                                        this.isPatientArchived && this.showPatientRestore,
                                    routerLink: ['/Patient/restore'],
                                },
                                {
                                    label:
                                        this.preferences?.significantEvents || 'Significant Events',
                                    icon: 'event',
                                    visible:
                                        this.userRole?.significantEvents && this.showSignificantEvent && this.isPatientArchived ,
                                    routerLink: ['/Patient/events/list'],
                                },
                                {
                                    label: this.preferences?.vitals || 'Vitals',
                                    icon: 'equalizer',
                                    visible: this.userRole?.vitals,
                                    routerLink: ['/Patient/vitals/list'],
                                },
                                {
                                    label: this.preferences?.financials || 'Financials',
                                    icon: 'list_alt',
                                    visible: this.userRole?.financialSummary && CareFinitySession.practiceSettings.enableFinancialSummary,
                                    routerLink: ['/Patient/financial/list'],
                                },
                                {
                                    label: this.preferences?.notes || 'Patient Notes',
                                    icon: 'comment',
                                    visible: this.userRole?.notes && CareFinitySession.practiceSettings.showPatientNotes,
                                    routerLink: ['/Patient/notes/manage'],
                                },
                                {
                                    label: this.preferences?.charges || 'Charges',
                                    icon: 'list_alt',
                                    visible: this.userRole?.charge && CareFinitySession.practiceSettings.enableBilling,
                                    routerLink: ['/Patient/billing/list'],
                                },
                                {
                                    label:
                                        this.preferences?.exportDocuments || 'Export Clinical Data',
                                    icon: 'table_view',
                                    visible: this.userRole?.exportdocuments && CareFinitySession.practiceSettings.showExportDocuments, 
                                    routerLink: ['/Patient/exportdocuments/list'],
                                },
                            ],
                        },
                    ],
                },
            ]
        } else {
            this.ptmodel = [
                {
                    label: '',
                    icon: 'pi-users',
                    visible: sessionStorage.getItem('ptName') != null,
                    items: [
                        {
                            label: 'Patient',
                            icon: PrimeIcons.USERS,
                            routerLink: ['/Patient'],
                            items: [
                                {
                                    label: 'Dashboard',
                                    icon: 'dashboard',
                                    visible: true,
                                    routerLink: ['/Patient/dashboard'],
                                },
                                {
                                    label: this.preferences?.problems || 'Problems',
                                    icon: 'error',
                                    visible: this.userRole?.problems,
                                    routerLink: ['/Patient/problems/list'],
                                },
                                {
                                    label: this.preferences?.allergies || 'Allergies',
                                    icon: 'pets',
                                    visible: this.userRole?.allergies,
                                    routerLink: ['/Patient/allergy/list'],
                                },
                                {
                                    label: this.preferences?.medications || 'Medication',
                                    icon: 'add',
                                    visible: this.userRole?.medication,
                                    routerLink: ['/Patient/medication/list'],
                                },
                                {
                                    label: this.preferences?.visits || 'Visits',
                                    icon: 'queue',
                                    visible: this.userRole?.visits,
                                    routerLink: ['/Patient/visits/list'],
                                },
                                {
                                    label: this.preferences?.labs || 'Labs',
                                    icon: 'equalizer',
                                    visible: this.userRole?.labs,
                                    routerLink: ['/Patient/labs/list'],
                                },
                                {
                                    label: this.preferences?.orders || 'Orders',
                                    icon: 'adjust',
                                    visible: this.userRole?.orders,
                                    routerLink: ['/Patient/orders/list'],
                                },
                                {
                                    label: this.preferences?.documents || 'Documents',
                                    icon: 'table_view',
                                    visible: this.userRole?.documents && CareFinitySession.practiceSettings.showPatientDocuments,
                                    routerLink: ["/Patient/documents/catlist"],

                                },

                                {
                                    label: this.preferences?.images || 'Images',
                                    icon: 'image',
                                    visible: this.userRole?.images && CareFinitySession.practiceSettings.showPatientImage,
                                    routerLink: ['/Patient/images/list'],
                                },
                                {
                                    label: 'Patient Restore',
                                    icon: 'event',
                                    visible:
                                        this.userRole?.showRestoreTabToUser &&
                                        this.isPatientArchived && this.showPatientRestore,
                                    routerLink: ['/Patient/restore'],
                                },
                                {
                                    label:
                                        this.preferences?.significantEvents || 'Significant Events',
                                    icon: 'event',
                                    visible:
                                        this.userRole?.significantEvents && this.isPatientArchived && this.showSignificantEvent,
                                    routerLink: ['/Patient/events/list'],
                                },
                                {
                                    label: this.preferences?.vitals || 'Vitals',
                                    icon: 'equalizer',
                                    visible: this.userRole?.vitals,
                                    routerLink: ['/Patient/vitals/list'],
                                },
                                {
                                    label: this.preferences?.financials || 'Financials',
                                    icon: 'list_alt',
                                    visible: this.userRole?.financialSummary && CareFinitySession.practiceSettings.enableFinancialSummary,
                                    routerLink: ['/Patient/financial/list'],
                                },
                                {
                                    label: this.preferences?.notes || 'Patient Notes',
                                    icon: 'comment',
                                    visible: this.userRole?.notes && CareFinitySession.practiceSettings.showPatientNotes,
                                    routerLink: ['/Patient/notes/manage'],
                                },
                                {
                                    label: this.preferences?.charges || 'Charges',
                                    icon: 'list_alt',
                                    visible: this.userRole?.charge && CareFinitySession.practiceSettings.enableBilling,
                                    routerLink: ['/Patient/billing/list'],
                                },
                                {
                                    label:
                                        this.preferences?.exportDocuments || 'Export Documents',
                                    icon: 'table_view',
                                    visible: this.userRole?.exportdocuments && CareFinitySession.practiceSettings.showExportDocuments, 
                                    routerLink: ['/Patient/exportdocuments/list'],
                                },
                            ],
                        },
                    ],
                },
            ]
        }
    }

    //adminmodelsetup() {

    //    console.log("show navifations", CareFinitySession.showOnlyPatientNavigations)
    //    if (CareFinitySession.showOnlyPatientNavigations) return

    //    this.adminmodel = [
    //        {
    //            label: '',
    //            icon: 'settings',
    //            visible: true,
    //            items: [
    //                {
    //                    label: 'Administration',
    //                    icon: PrimeIcons.SHIELD,
    //                    routerLink: ['/administration'],
    //                    items: [
    //                        {
    //                            label: 'Manage Users',
    //                            icon: 'error',
    //                            visible: this.userRole?.manageUsers,
    //                            routerLink: ['/administration/user-list'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage Roles',
    //                            icon: 'security',
    //                            visible: this.userRole?.manageRoles,
    //                            routerLink: ['/administration/manage-roles'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage User Practices',
    //                            icon: 'security',
    //                            visible: this.userRole?.manageUserPractices,
    //                            routerLink: ['/administration/users-practice'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage Global Config',
    //                            icon: 'setting',
    //                            visible: this.userRole?.manageGlobalConfig,
    //                            routerLink: ['/administration/global-config'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage Practice Config',
    //                            icon: 'setting',
    //                            visible: this.userRole?.managePracticeConfig,
    //                            routerLink: ['/administration/practice-config'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage Global Settings',
    //                            icon: 'security',
    //                            visible: this.userRole?.manageGlobalSetting,
    //                            routerLink: ['/administration/listmapping'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Manage Report Categories',
    //                            icon: 'flight_land',
    //                            visible: this.userRole?.manageReports,
    //                            routerLink: ['/administration/report-categories'],
    //                        },
    //                        {
    //                            label: 'Manage Reports',
    //                            icon: 'hourglass_empty',
    //                            visible: this.userRole?.manageReports,
    //                            routerLink: ['/administration/manage-reports'],
    //                        },
    //                        {
    //                            label: 'Manage Notes',
    //                            icon: 'verified_user',
    //                            visible: this.userRole?.manageNotes,
    //                            routerLink: ['/administration/manage-notes'],
    //                        },
    //                        {
    //                            label: 'Patient Archive',
    //                            icon: 'settings_backup_restore',
    //                            visible: this.userRole?.patientArchive,
    //                            routerLink: ['/administration/patient-archive'],
    //                            target: '_blank',
    //                        },
    //                        //{
    //                        //    label: 'Patient Demographics',
    //                        //    icon: 'settings_applications',
    //                        //    visible: this.userRole?.patientDemographics,
    //                        //    routerLink: ['/administration/patient-demographics'],
    //                        //    target: '_blank',
    //                        //},
    //                        {
    //                            label: 'Manage Security Question',
    //                            icon: 'question_answer',
    //                            visible: this.userRole?.securityQuestions,
    //                            routerLink: ['/administration/manage-questions'],
    //                            target: '_blank',
    //                        },

    //                        {
    //                            label: 'Reset All Passwords',
    //                            icon: 'vpn_lock',
    //                            visible: this.userRole?.resetAllPasswords,
    //                            routerLink: ['/administration/reset-password-group'],
    //                            target: '_blank',
    //                        },
    //                        {
    //                            label: 'Emergency Token',
    //                            icon: 'vpn_key',
    //                            visible:
    //                                this.userRole?.emergencyToken &&
    //                                CareFinitySession.applicationSettings?.isEmergencyTokenEnabled,
    //                            routerLink: ['/administration/security-token'],
    //                            target: '_blank',
    //                        },
    //                    ],
    //                },
    //            ],
    //        },
    //        {
    //            label: '',
    //            icon: 'vpn_lock',
    //            visible: true,
    //            items: [
    //                {
    //                    label: 'Change Password',
    //                    icon: PrimeIcons.LOCK,
    //                    visible: true,
    //                    routerLink: ['/settings/change-password'],
    //                },
    //            ],
    //        },
    //    ]
    //}

  
    adminmodelsetup() {

        console.log("show navifations", CareFinitySession.showOnlyPatientNavigations)
        if (CareFinitySession.showOnlyPatientNavigations) return

        if (this.hasAdministrationPrivillages()) {
            this.adminmodel = [
                {
                    label: '',
                    icon: 'settings',
                    visible: true,
                    items: [
                        {
                            label: 'Administration',
                            icon: PrimeIcons.SHIELD,
                            routerLink: ['/administration'],
                            items: [

                                {
                                    label: 'Manage Global Config',
                                    icon: 'setting',
                                    visible: this.userRole?.manageGlobalConfig,
                                    routerLink: ['/administration/global-config'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Manage Practice Config',
                                    icon: 'setting',
                                    visible: this.userRole?.managePracticeConfig,
                                    routerLink: ['/administration/practice-config'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Manage Global Settings',
                                    icon: 'security',
                                    visible: this.userRole?.manageGlobalSetting,
                                    routerLink: ['/administration/listmapping'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Manage Roles',
                                    icon: 'security',
                                    visible: this.userRole?.manageRoles,
                                    routerLink: ['/administration/manage-roles'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Manage Users',
                                    icon: 'error',
                                    visible: this.userRole?.manageUsers,
                                    routerLink: ['/administration/user-list'],
                                    target: '_blank',
                                },                               
                                {
                                    label: 'Manage User Practices',
                                    icon: 'security',
                                    visible: this.userRole?.manageUserPractices,
                                    routerLink: ['/administration/users-practice'],
                                    target: '_blank',
                                },                
                                
                                {
                                    label: 'Manage Report Categories',
                                    icon: 'flight_land',
                                    visible: this.userRole?.manageReports,
                                    routerLink: ['/administration/report-categories'],
                                },
                                {
                                    label: 'Manage Reports',
                                    icon: 'hourglass_empty',
                                    visible: this.userRole?.manageReports,
                                    routerLink: ['/administration/manage-reports'],
                                },
                                {
                                    label: 'Manage Notes',
                                    icon: 'verified_user',
                                    visible: this.userRole?.manageNotes && CareFinitySession.practiceSettings.showPatientNotes,
                                    routerLink: ['/administration/manage-notes'],
                                },
                                {
                                    label: 'Patient Archive',
                                    icon: 'settings_backup_restore',
                                    visible: this.userRole?.patientArchive && CareFinitySession.practiceSettings.showPatientArchive,
                                    routerLink: ['/administration/patient-archive'],
                                    target: '_blank',
                                },
                                //{
                                //    label: 'Patient Demographics',
                                //    icon: 'settings_applications',
                                //    visible: this.userRole?.patientDemographics,
                                //    routerLink: ['/administration/patient-demographics'],
                                //    target: '_blank',
                                //},
                                {
                                    label: 'Manage Security Question',
                                    icon: 'question_answer',
                                    visible: this.userRole?.securityQuestions,
                                    routerLink: ['/administration/manage-questions'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Manage API Keys',
                                    icon: 'vpn_key',
                                    visible:
                                        this.userRole?.globalAdminPrivilege,
                                    routerLink: ['/administration/api_keys'],
                                },

                                {
                                    label: 'Reset All Passwords',
                                    icon: 'vpn_lock',
                                    visible: this.userRole?.resetAllPasswords,
                                    routerLink: ['/administration/reset-password-group'],
                                    target: '_blank',
                                },
                                {
                                    label: 'Emergency Token',
                                    icon: 'vpn_key',
                                    visible: this.userRole?.eMERGENCY_TOKEN && CareFinitySession.applicationSettings?.isEmergencyTokenEnabled,
                                    routerLink: ['/administration/security-token'],
                                    target: '_blank',
                                },
                            ],
                        },
                    ],
                },
                {
                    label: '',
                    icon: 'vpn_lock',
                    visible: true,
                    items: [

                        //{
                        //    label: 'User Preference Settings',
                        //    icon: PrimeIcons.BRIEFCASE,
                        //    //  visible: this.userRole?.manageRoles,
                        //    routerLink: ['/settings/user-pref'],
                        //    target: '_blank',
                        //},
                        {
                            label: 'Change Password',
                            icon: PrimeIcons.LOCK,
                            visible: true,
                            routerLink: ['/settings/change-password'],
                        }
                        
                    ],
                },
            ]
        }
        else {
            this.adminmodel = [
                {
                    label: '',
                    icon: 'settings',
                    visible: true,
                    items: [
                        {
                            label: 'Change Password',
                            icon: PrimeIcons.LOCK,
                            routerLink: ['/settings/change-password'],
                            items: [
                                {
                                    label: 'Change Password',
                                    visible: true,
                                    routerLink: ['/settings/change-password'],
                                },


                            ],
                        },
                    ],
                },

            ]
        }

    }


    recentlyvisitedmodelsetup() {
        if (CareFinitySession.showOnlyPatientNavigations) return

        switch (this.ptVisited.length) {
            case 1: {
                this.recentlyvisptmodel = [
                    {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'Recently Visited',
                                icon: PrimeIcons.EYE,
                                items: [
                                    {
                                        /*routerLink: ['/Patient/dashboard/' + this.ptVisited[0].patientName], // Define the base route*/
                                        /*routerLink: ['/Patient/dashboard/1'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[0].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 1;
                                            this.navigateToDashboard(this.ptVisited[0], idx)
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ]

                break
            }
            case 2: {
                this.recentlyvisptmodel = [
                    {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'Recently Visited',
                                icon: PrimeIcons.EYE,
                                items: [
                                    {
                                        /*routerLink: ['/Patient/dashboard/' + this.ptVisited[0].patientName], // Define the base route*/
                                        /*routerLink: ['/Patient/dashboard/1'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[0].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 1;
                                            this.navigateToDashboard(this.ptVisited[0], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[1].patientName], // Define the base route
                                        //routerLink: ['/Patient/dashboard/2'], // Define the base route
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[1].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 2;
                                            this.navigateToDashboard(this.ptVisited[1], idx)
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ]

                break
            }
            case 3: {
                this.recentlyvisptmodel = [
                    {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'Recently Visited',
                                icon: PrimeIcons.EYE,
                                items: [
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[0].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/1'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[0].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 1;
                                            this.navigateToDashboard(this.ptVisited[0], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[1].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/2'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[1].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 2;
                                            this.navigateToDashboard(this.ptVisited[1], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[2].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/3'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[2].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 3;
                                            this.navigateToDashboard(this.ptVisited[2], idx)
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ]

                break
            }

            case 4: {
                this.recentlyvisptmodel = [
                    {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'Recently Visited',
                                icon: PrimeIcons.EYE,
                                items: [
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[0].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/1'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[0].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 1;
                                            this.navigateToDashboard(this.ptVisited[0], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[1].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/2'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[1].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 2;
                                            this.navigateToDashboard(this.ptVisited[1], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[2].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/3'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[2].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 3;
                                            this.navigateToDashboard(this.ptVisited[2], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[3].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/4'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[3].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 4;
                                            this.navigateToDashboard(this.ptVisited[3], idx)
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ]

                break
            }
            case 5: {
                this.recentlyvisptmodel = [
                    {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'Recently Visited',
                                icon: PrimeIcons.EYE,
                                items: [
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[0].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/1'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[0].patientName,
                                        routerLinkActiveOptions: { exact: false },
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 1;
                                            this.navigateToDashboard(this.ptVisited[0], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[1].patientName], // Define the base route
                                        //routerLink: ['/Patient/dashboard/2'], // Define the base route
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[1].patientName,
                                        routerLinkActiveOptions: { exact: false },
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 2;
                                            this.navigateToDashboard(this.ptVisited[1], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[2].patientName], // Define the base route
                                        //routerLink: ['/Patient/dashboard/3'], // Define the base route
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[2].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 3;
                                            this.navigateToDashboard(this.ptVisited[2], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[3].patientName], // Define the base route
                                        /*routerLink: ['/Patient/dashboard/4'], // Define the base route*/
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[3].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 4;
                                            this.navigateToDashboard(this.ptVisited[3], idx)
                                        },
                                    },
                                    {
                                        //routerLink: ['/Patient/dashboard/' + this.ptVisited[4].patientName], // Define the base route
                                        //routerLink: ['/Patient/dashboard/5'], // Define the base route
                                        routerLink: ['/Patient/dashboard'], // Define the base route

                                        label: this.ptVisited[4].patientName,
                                        command: (event: any) => {
                                            //let routerSegments = event.item.routerLink[0].split('/');
                                            //let idx = +routerSegments[routerSegments.length - 1];
                                            let idx = 5;
                                            this.navigateToDashboard(this.ptVisited[4], idx)
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ]

                break
            }
        }
    }

    reportsCategoriesList: {
        label: string
        icon: string
        visible: boolean
        items: {
            label: string
            icon: string
            items: {
                label: string
                command: (event: any) => void
            }[]
        }[]
    }[]

    reportsPatientList: {
        label: string
        icon: string
        visible: boolean
        items: {
            label: string
            icon: string
            items: {
                label: string
                command: (event: any) => void
            }[]
        }[]
    }[]

    getReportsCategoriesModelSetup() {
        if (CareFinitySession.showOnlyPatientNavigations) return

        this.reportsCategoriesList = []
        let index = 0

        if (this.reportsCategoriesModel) {
            this.reportsCategoriesModel.forEach((category) => {
                let newCategory = {
                    label: '',
                    icon: '',
                    visible: false,
                    items: [],
                }

                if (index === 0) {
                    newCategory = {
                        label: '',
                        icon: 'eye',
                        visible: true,
                        items: [
                            {
                                label: 'View Reports',
                                routerLink: ['/ViewReports'], // Define the base route
                                icon: PrimeIcons.FILE,
                                items: [
                                    {

                                        routerLink: ['/ViewReports/category-reports-view/' + index], // Define the base route

                                        label: this.reportsCategoriesModel[0].reportCategoryName,
                                        routerLinkActiveOptions: { exact: false },
                                        command: (event: any) => {
                                            let routerSegments = event.item.routerLink[0].split('/');
                                            let idx = +routerSegments[routerSegments.length - 1];
                                            this.navigateToCategoryReportsView(
                                                idx,
                                                category.reportCategoryId,
                                                category.reportCategoryName,
                                            )
                                        },
                                    },
                                ],
                            },
                        ],
                    }

                    this.reportsCategoriesList.push(newCategory)
                } else {
                    let newItem = {

                        routerLink: ['/ViewReports/category-reports-view/' + index], // Define the base route

                        label: category.reportCategoryName,
                        routerLinkActiveOptions: { exact: false },
                        command: (event: any) => {
                            let routerSegments = event.item.routerLink[0].split('/');
                            let idx = +routerSegments[routerSegments.length - 1];
                            this.navigateToCategoryReportsView(
                                idx,
                                category.reportCategoryId,
                                category.reportCategoryName,
                            )
                        },
                    }

                    this.reportsCategoriesList[0].items[0].items.push(newItem)
                }

                index += 1
            })
        }
    }

    //getReportsOfPatientModelSetup() {
    //    if (CareFinitySession.showOnlyPatientNavigations) return

    //    this.reportsPatientList = []
    //    let firstItem = { };
    //    let index = 0
    //    debugger
    //    if (this.reportsPatientsModel) {
    //        this.reportsPatientsModel.forEach((report) => {

    //          //  alert(report.reportDisplayName)
    //            let newReport = {
    //                label: '',
    //                icon: '',
    //                visible: false,
    //                items: [],
    //            }

    //            if (index === 0) {
    //                alert(report.reportDisplayName);
    //                alert(index);

    //                newReport = {
    //                    label: '',
    //                    icon: 'eye',
    //                    visible: false,
    //                    items: [
    //                        {
    //                            routerLink: ['/ViewReports/category-reports-view/' + index], // Define the base route

    //                            label: 'Patient Specific Reports',
    //                            icon: PrimeIcons.FILE,
    //                            items: [
    //                                {
    //                                    label: this.reportsPatientsModel[0].reportDisplayName,
    //                                    routerLinkActiveOptions: { exact: false },
    //                                    command: (event: any) => {
    //                                        let routerSegments = event.item.routerLink[0].split('/');
    //                                        let idx = +routerSegments[routerSegments.length - 1];
    //                                        this.navigateToReportsView(idx,report.reportID,report.reportDisplayName)
    //                                    },
    //                                },
    //                            ],
    //                        },
    //                    ],
    //                }



    //                 firstItem = {
    //                    routerLink: ['/ViewReports/category-reports-view/' + index], // Define the base route
    //                    label: report.reportDisplayName,
    //                    routerLinkActiveOptions: { exact: false },
    //                    command: (event: any) => {
    //                        let routerSegments = event.item.routerLink[0].split('/');
    //                        let idx = +routerSegments[routerSegments.length - 1];
    //                        this.navigateToReportsView(
    //                            idx,
    //                            report.reportID,
    //                            report.reportDisplayName,
    //                        )
    //                    },
    //                }




    //               // this.reportsPatientList.push(newReport.items[0])
    //                this.reportsPatientList.push((newReport))




    //            } else
    //            {

    //                alert("a");
    //                alert(index);
    //                alert(report.reportDisplayName);
    //                let newItem = {
    //                    routerLink: ['/ViewReports/category-reports-view/' + index], // Define the base route

    //                    label: report.reportDisplayName,
    //                    routerLinkActiveOptions: { exact: false },
    //                    command: (event: any) => {
    //                        let routerSegments = event.item.routerLink[0].split('/');
    //                        let idx = +routerSegments[routerSegments.length - 1];
    //                        this.navigateToReportsView(
    //                            idx,
    //                            report.reportID,
    //                            report.reportDisplayName,
    //                        )
    //                    },
    //                }

    //                this.reportsPatientList[0].items[0].items.push(newItem)
    //            }

    //            index += 1
    //        })
    //    }


    //    this.reportsPatientList[0].items[0].items.shift();

    //    this.reportsPatientList[0].items[0].items.push(firstItem)



    //}



    getReportsOfPatientModelSetup() {
/*        if (CareFinitySession.showOnlyPatientNavigations) return;
*/
        this.reportsPatientList = [];
        let firstItem: { routerLink: string[]; label: string; routerLinkActiveOptions: { exact: boolean }; command: (event: any) => void } | null = null;
        let index = 0;

        if (this.reportsPatientsModel) {
            this.reportsPatientsModel.forEach((report) => {
                let newReport = {
                    label: '',
                    icon: '',
                    visible: false,
                    items: [],
                };

                if (index === 0) {
                    //alert(report.reportDisplayName);
                    //alert(index);

                    newReport = {
                        label: '',
                        icon: 'eye',
                        visible: false,
                        items: [
                            {
                                routerLink: ['/ViewReports/category-reports-view/' + index],
                                label: 'Patient Specific Reports',
                                icon: PrimeIcons.FILE,
                                items: [
                                    {
                                        label: this.reportsPatientsModel[0].reportDisplayName,
                                        routerLinkActiveOptions: { exact: false },
                                        command: (event: any) => {
                                            let routerSegments = event.item.routerLink[0].split('/');
                                            let idx = +routerSegments[routerSegments.length - 1];
                                            this.navigateToReportsView(idx, report.reportID, report.reportDisplayName);
                                        },
                                    },
                                ],
                            },
                        ],
                    };

                    // Define firstItem with the correct structure
                    firstItem = {
                        routerLink: ['/ViewReports/category-reports-view/' + index],
                        label: report.reportDisplayName,
                        routerLinkActiveOptions: { exact: false },
                        command: (event: any) => {
                            let routerSegments = event.item.routerLink[0].split('/');
                            let idx = +routerSegments[routerSegments.length - 1];
                            this.navigateToReportsView(
                                idx,
                                report.reportID,
                                report.reportDisplayName,
                            );
                        },
                    };

                    this.reportsPatientList.push(newReport);
                } else {
                    //alert("a");
                    //alert(index);
                    //alert(report.reportDisplayName);

                    let newItem = {
                        routerLink: ['/ViewReports/category-reports-view/' + index],
                        label: report.reportDisplayName,
                        routerLinkActiveOptions: { exact: false },
                        command: (event: any) => {
                            let routerSegments = event.item.routerLink[0].split('/');
                            let idx = +routerSegments[routerSegments.length - 1];
                            this.navigateToReportsView(
                                idx,
                                report.reportID,
                                report.reportDisplayName,
                            );
                        },
                    };

                    // Ensure the nested structure exists before pushing newItem
                    if (!this.reportsPatientList[0].items[0].items) {
                        this.reportsPatientList[0].items[0].items = [];
                    }

                    this.reportsPatientList[0].items[0].items.push(newItem);
                }

                index += 1;
            });
        }

        // Ensure the structure exists before accessing it
        if (this.reportsPatientList.length > 0) {
            // Ensure 'items' exists
            if (!this.reportsPatientList[0].items) {
               // this.reportsPatientList[0].items = [{ items: [] }];
            } else if (!this.reportsPatientList[0].items[0].items) {
                this.reportsPatientList[0].items[0].items = [];
            }

            // Safely push 'firstItem' now
            if (firstItem) { // Check if firstItem is not null
                this.reportsPatientList[0].items[0].items.shift(); // Remove the first item if needed
                this.reportsPatientList[0].items[0].items.push(firstItem); // Push the first item
            }
        }
    }


    hasAdministrationPrivillages(): boolean {
        let isAdmin = false;


        if (this.userRole?.manageUsers || this.userRole?.manageUserPractices || this.userRole?.manageRoles || this.userRole?.manageGlobalConfig || this.userRole?.managePracticeConfig || this.userRole?.globalAdminPrivilege || this.userRole?.manageNotes || this.userRole?.resetAllPasswords) {
            isAdmin = true;
        }
        else {
            isAdmin = false;
        }


        return isAdmin;

    }

    }

